import { Avatar, Box, Chip, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setInspectionSelectedItem } from 'app/actions/transport';
import { Autosizer, Scrollbar } from 'app/components';
import { InspectionIcon } from 'app/icons';
import React, { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
const TransportInspectionList = () => {
    const dispatch = useDispatch();
    const { inspections } = useSelector((state) => state.transport.selectedItem);
    const { inspectionSelectedItem } = useSelector((state) => state.transport);
    const handleItemClick = (value) => dispatch(setInspectionSelectedItem(value));
    return (React.createElement(Box, { component: 'div', sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            '.MuiListItem-root': {
                width: '100%',
                userSelect: 'none',
                padding: theme.spacing(0),
                borderRadius: '0',
                '&.Mui-selected .MuiListItemText-secondary': {
                    color: alpha(theme.palette.primary.contrastText, 0.85),
                },
                '.MuiListItemIcon-root': {
                    justifyContent: 'end',
                    '.MuiCheckbox-root': {
                        padding: theme.spacing(0),
                        marginRight: theme.spacing(0),
                        svg: {
                            fontSize: '18px',
                        },
                    },
                },
                '.MuiListItemAvatar-root': {
                    minWidth: '36px',
                },
                '.MuiAvatar-circular': {
                    color: theme.palette.primary.main,
                    bgcolor: alpha(theme.palette.primary.main, 0.12),
                    marginRight: '8px',
                    svg: {
                        fontSize: '16px',
                        path: {
                            fill: theme.palette.primary.main,
                        },
                    },
                },
                '.MuiListItemButton-root': {
                    padding: theme.spacing(1, 2),
                    borderRadius: '0',
                },
                '.MuiListItemText-root': {
                    margin: theme.spacing(0),
                },
                '.MuiChip-root': {
                    height: '20px',
                    span: {
                        fontSize: '10px',
                        color: 'white',
                    },
                },
            },
        }) },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => (React.createElement(FixedSizeList, { height: height, itemSize: 47, overscanCount: 10, itemCount: inspections.length, innerRef: contentNodeRef, outerRef: scrollableNodeRef, innerElementType: TransportInspectionListInnerElementType, itemData: {
                    items: inspections,
                    selectedItem: inspectionSelectedItem,
                    onClick: handleItemClick,
                } }, TransportInspectionListItemRender))))))));
};
const TransportInspectionListInnerElementType = forwardRef((props, ref) => (React.createElement(List, Object.assign({ ref: ref, disablePadding: true }, props))));
TransportInspectionListInnerElementType.displayName = 'TransportInspectionListInnerElementType';
const TransportInspectionListItemRender = ({ data, index, style }) => {
    const { items, selectedItem, onClick } = data;
    const item = items[index];
    return (React.createElement(ListItem, { key: item.id, style: style, onClick: () => onClick(item), selected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === item.id, secondaryAction: React.createElement(Chip, { size: 'small', label: item.status ? 'Выезд разрешен' : 'Выезд запрещен', color: item.status ? 'success' : 'error' }) },
        React.createElement(ListItemButton, null,
            React.createElement(ListItemAvatar, null,
                React.createElement(Avatar, null,
                    React.createElement(InspectionIcon, { fontSize: 'small' }))),
            React.createElement(ListItemText, { primary: item.name, secondary: moment(item.created_at).format('DD.MM.YYYY HH:mm:ss') }))));
};
export default TransportInspectionList;
